import { FC } from "react";
import { Outlet } from "react-router-dom";

import { AppNavigationDesktop } from "../AppNavigation/AppNavigationDesktop";
import { Container } from "../Container";
import { TopBar } from "../TopBar";

import styles from "./AppLayout.module.scss";

export const AppLayout: FC = () => (
  <div className={styles.wrapper}>
    <AppNavigationDesktop />
    <Container>
      <TopBar />
      <Outlet />
    </Container>
  </div>
);
